import BillingModel from "../../../../types/billing-model";
import BillingStatus from "../../../../types/billing-status";
import TaxiCorporationBillingType from "../../../../types/taxi-corporation-billing-type";

export enum TaxiCorporationOrderBillingsListParamsOrder {
  DISTANCE_ASC = "DISTANCE_ASC",
  DISTANCE_DESC = "DISTANCE_DESC",
  HIGHWAY_CHARGE_ASC = "HIGHWAY_CHARGE_ASC",
  HIGHWAY_CHARGE_DESC = "HIGHWAY_CHARGE_DESC",
  HALTING_AMOUNT_ASC = "HALTING_AMOUNT_ASC",
  HALTING_AMOUNT_DESC = "HALTING_AMOUNT_DESC",
  HUMAN_ID_ASC = "HUMAN_ID_ASC",
  HUMAN_ID_DESC = "HUMAN_ID_DESC",
  BILLING_MODEL_ASC = "BILLING_MODEL_ASC",
  BILLING_MODEL_DESC = "BILLING_MODEL_DESC",
  DISTANCE_RATE_ASC = "DISTANCE_RATE_ASC",
  DISTANCE_RATE_DESC = "DISTANCE_RATE_DESC",
  DISTANCE_AMOUNT_ASC = "DISTANCE_AMOUNT_ASC",
  DISTANCE_AMOUNT_DESC = "DISTANCE_AMOUNT_DESC",
  TOTAL_AMOUNT_ASC = "TOTAL_AMOUNT_ASC",
  TOTAL_AMOUNT_DESC = "TOTAL_AMOUNT_DESC",
}

type TaxiCorporationOrderBillingsListParams = {
  taxiCorporationUuid: string;
  limit: number;
  offset: number;
  order?: TaxiCorporationOrderBillingsListParamsOrder;
  humanId?: number;
  planEntryHumanIds?: number;
  dateSince?: string;
  dateTo?: string;
  cargoCompany?: string;
  excludeCargoCompany?: string;
  passenger?: string;
  status?: BillingStatus;
  billingModel?: BillingModel;
  billingType?: TaxiCorporationBillingType;
  responsibleTaxi?: string;
};

export default TaxiCorporationOrderBillingsListParams;
